export enum MsGraphPermissions {
  USER_READ = "user.read",
}
